import React, { useEffect, useRef, useState } from 'react'
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import {
    setComments, checkedState, unCheckedState, checkedAllState, unCheckedAllState, SingleApproveAsync, SingleRejectAsync
} from './TimeOffApprovalSlice';
import moment from 'moment';
import AttachmentModal from '../../attachment/AttachmentModal';
import '../../../common/css/timeLive.css'
import './TimeOffApproval.css'
import { ShowSwalWithConfirmationMessage } from '../../../common/SweetAlert';
import { ShowToast } from '../../../common/Toastr';
import { formatDateWithDateAndMonthName, determineCultureFormat, getValueFromResource, FormatInvoiceDecimalNumber } from '../../../common/timeLiveFunction';
import { parseISO, format } from "date-fns"

const TimeOffApprovedItems = (props: any) => {
    const { timeOffApprovedList, t, IsEdit, isShowTimeOffInDays } = props;
    const { cultureInfoName } = useAppSelector((state) => state.globalState);
    const popupRef = useRef<any>(null);
    const approvedButtonRef = useRef<any>(null);
    const rejectedButtonRef = useRef<any>(null);
    const modelRef = useRef<any>(null);
    const [id, setId] = useState(null);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const dispatch = useAppDispatch();

    useEffect(() => {
        if (modalIsOpen) {
            if (modelRef.current) {
                modelRef.current.click();
            }
        }
    }, [modalIsOpen])

     

    const renderEmployeeNameWithSystemApproverType = (FullName: string, StartDate: any, EndDate: any, SystemApproverTypeId: any) => {
        let SystemApproverType: string = "";
        let SystemApproverTypeToolTip: string = "";

        if (SystemApproverTypeId == 1) {
            SystemApproverType = "(TL)";
            SystemApproverTypeToolTip = "Team Lead";
        }
        else if (SystemApproverTypeId == 2) {
            SystemApproverType = "(PM)";
            SystemApproverTypeToolTip = "Project Manager";
        }
        else if (SystemApproverTypeId == 3) {
            SystemApproverType = "(SE)";
            SystemApproverTypeToolTip = "Specific Employee";
        }
        else if (SystemApproverTypeId == 4) {
            SystemApproverType = "(EU)";
            SystemApproverTypeToolTip = "External User";
        }
        else if (SystemApproverTypeId == 5) {
            SystemApproverType = "(EM)";
            SystemApproverTypeToolTip = "Employee Manager";
        }
        return (
            <>
                <a className='text-dark fw-bold d-block mb-1'>
                    {FullName} {SystemApproverType}
                </a>
                <span style={{ color: '#7b8ba6', fontSize: 11 ,   display: 'inline-flex', alignItems: 'center' }} >
                    <i className="ki-outline ki-calendar text-gray fs-4 me-1 "></i>
                    {/* {moment.parseZone(StartDate).format('DD MMM yy')} - {moment.parseZone(EndDate).format('DD MMM yy')} */}
                    {formatDateWithDateAndMonthName(StartDate, cultureInfoName.toString())} - {formatDateWithDateAndMonthName(EndDate, cultureInfoName.toString())}
                </span>
            </>
        );
    }

    const handleAttachment = (AccountEmployeeTimeOffRequestId: any) => {
        setId(AccountEmployeeTimeOffRequestId);
        setModalIsOpen(true);
    }


    return (
        <>
            <table className="table table-row-bordered  align-middle gs-1 gy-1 gx-1" >
                <thead>
                    <tr className="thHeading align-middle">
                       
                        <th className='col'>
                            {/* {t('Employee Name')} */}
                            {getValueFromResource('Employee Name', dispatch, t)}
                        </th>
                        <th className='col'>
                            {/* {t('Time Off Type')} */}
                            {getValueFromResource('Time Off Type', dispatch, t)}
                        </th>
                        <th className='col'>{isShowTimeOffInDays ? getValueFromResource('Total Days', dispatch, t) : getValueFromResource('Total Hours', dispatch, t)}</th>
                        <th className='col'>{isShowTimeOffInDays ? getValueFromResource('Hours Off', dispatch, t) : getValueFromResource('Days Off', dispatch, t)}</th>
                        <th className='col'>{isShowTimeOffInDays ? getValueFromResource('Available Days', dispatch, t) : getValueFromResource('Available Hours', dispatch, t)}</th>
                        <th className='w-25px text-center'></th>
                    </tr>
                </thead>
                <tbody>
                    {timeOffApprovedList.length > 0 && timeOffApprovedList.map((timeOffApproval: any, i: any) => (
                       
                            <tr key={i}>
                              
                                <td>
                                    {renderEmployeeNameWithSystemApproverType(timeOffApproval.FullName, timeOffApproval.StartDate, timeOffApproval.EndDate, timeOffApproval.SystemApproverTypeId)}
                                </td>
                                <td>
                                    <span className="d-block mb-1">
                                        {timeOffApproval.AccountTimeOffType}
                                    </span>
                                    {timeOffApproval.Description !== "" ? (
                                        <a
                                            style={{ fontSize: 'x-small', fontWeight: '500', lineHeight: '.7', cursor: 'pointer' }}
                                            className='text-dark fw-bold d-block'
                                            data-tooltip-id="tooltip-Description"
                                            data-tooltip-content={t(`${timeOffApproval.Description}`)}
                                            data-tooltip-place="bottom"
                                        >
                                            {/* {t('View Description')} */}
                                            {getValueFromResource('View Description', dispatch, t)}
                                        </a>
                                    ) : null}
                                </td>
                                <td>
                                    {isShowTimeOffInDays ? (
                                        <>
                                            <a className='text-dark fw-bold d-inline-block'>
                                                {/* {(timeOffApproval.DayOff != "" && parseFloat(timeOffApproval.DayOff) > 0) ? parseFloat(timeOffApproval.DayOff) : 0} */}
                                                {(timeOffApproval.DayOff != "" && parseFloat(timeOffApproval.DayOff) > 0) ? FormatInvoiceDecimalNumber(cultureInfoName.toString(), timeOffApproval.DayOff, 2) : 0}
                                            </a>
                                            <span style={{ color: '#7b8ba6', fontSize: 11, marginLeft: '3px', display: 'inline-block' }}>
                                                {/* {t('days')}  */}
                                                {getValueFromResource('days', dispatch, t)}
                                            </span>
                                        </>
                                    ) : (
                                        <>
                                            <a className='text-dark fw-bold d-inline-block' >
                                                {(timeOffApproval.HoursOff !== "" && parseFloat(timeOffApproval.HoursOff) > 0) ? FormatInvoiceDecimalNumber(cultureInfoName.toString(), timeOffApproval.HoursOff , 2): 0}
                                            </a>
                                            <span style={{ color: '#7b8ba6', fontSize: 11, marginLeft: '3px', display: 'inline-block' }}>
                                                {/* {t('hrs')}  */}
                                                {getValueFromResource('hrs', dispatch, t)}
                                            </span>
                                        </>
                                    )}
                                </td>
                                <td>
                                    {isShowTimeOffInDays ? (
                                        <>
                                            <a className='text-dark fw-bold d-inline-block'>
                                                {(timeOffApproval.HoursOff != "" && parseFloat(timeOffApproval.HoursOff) > 0) ? FormatInvoiceDecimalNumber(cultureInfoName.toString(), timeOffApproval.HoursOff , 2) : 0}
                                            </a>
                                            <span style={{ color: '#7b8ba6', fontSize: 11, marginLeft: '3px', display: 'inline-block' }}>
                                                {/* {t('hrs')}   */}
                                                {getValueFromResource('hrs', dispatch, t)}
                                            </span>
                                        </>
                                    ) : (
                                        <>
                                            <a className='text-dark fw-bold d-inline-block'>
                                                {(timeOffApproval.DayOff != "" && parseFloat(timeOffApproval.DayOff) > 0) ? FormatInvoiceDecimalNumber(cultureInfoName.toString(), timeOffApproval.DayOff , 2) : 0}
                                            </a>
                                            <span style={{ color: '#7b8ba6', fontSize: 11, marginLeft: '3px', display: 'inline-block' }}>
                                                {/* {t('days')} */}
                                                {getValueFromResource('days', dispatch, t)}
                                            </span>
                                        </>
                                    )}
                                </td>
                                <td>
                                    {isShowTimeOffInDays ? (
                                        <>
                                            <a className='text-dark fw-bold d-inline-block'>
                                                {(timeOffApproval.AvailableDay != "" && parseFloat(timeOffApproval.AvailableDay) > 0) ?  FormatInvoiceDecimalNumber(cultureInfoName.toString(), timeOffApproval.AvailableDay , 2) : 0}
                                            </a>
                                            <span style={{ color: '#7b8ba6', fontSize: 11, marginLeft: '3px', display: 'inline-block' }}>
                                                {/* {t('days')}   */}
                                                {getValueFromResource('days', dispatch, t)}
                                            </span>
                                        </>
                                    ) : (
                                        <>
                                            <a className='text-dark fw-bold d-inline-block'>
                                                {(timeOffApproval.Available != "" && parseFloat(timeOffApproval.Available) > 0) ? FormatInvoiceDecimalNumber(cultureInfoName.toString(), timeOffApproval.Available , 2) : 0}
                                            </a>
                                            <span style={{ color: '#7b8ba6', fontSize: 11, marginLeft: '3px', display: 'inline-block' }}>
                                                {/* {t('hrs')}   */}
                                                {getValueFromResource('hrs', dispatch, t)}
                                            </span>
                                        </>
                                    )}
                                </td>
                               
                                <td>
                                    <div className="btn-group" style={{ float: 'right' }}>                                      
                                        <a
                                            className="btn btn-icon btn-active-light-dark btn-sm ms-0"
                                            data-tooltip-id="tooltip-Description"
                                            data-tooltip-content=
                                            // {t("Attachment")}
                                            {getValueFromResource('Attachment', dispatch, t)}
                                            data-tooltip-place="top"
                                            onClick={() => handleAttachment(timeOffApproval.AccountEmployeeTimeOffRequestId)}
                                        >
                                            <i className="bi bi-paperclip fs-3 iconColor"></i>
                                        </a>
                                    </div>
                                </td>
                            </tr>
                       
                    ))}
                </tbody>
            </table>
            {timeOffApprovedList.length === 0 &&
                <div className=''>
                    <p className='noDataFound'>
                        {/* {t('No Record Found')} */}
                        {getValueFromResource('No Record Found', dispatch, t)}
                    </p>
                </div>
            }
            {
                modalIsOpen && (
                    <>
                        <AttachmentModal
                            isOpen={modalIsOpen}
                            closeModal={() => setModalIsOpen(false)}
                            Id={id}
                            IsUploadRequired={false}
                            AccountAttachmentTypeId={3}
                        />

                    </>
                )
            }
        </>
    )
}

export default TimeOffApprovedItems